export default "__VITE_ASSET__aAKU5gRS__"